import { BoostPostServices, BoostPostServiceDependencies } from '../types/services';
import { createBoostPostService } from '../services/boostPostService';
import { createOptimisticStateService } from '../services/optimisticStateService';

/**
 * Creates and wires together the boost post services
 *
 * This factory creates both the boost post service and optimistic state service,
 * and properly wires their dependencies together.
 */
export const createBoostPostServices = (deps: BoostPostServiceDependencies): BoostPostServices => {
  const {
    createCampaignMutation,
    createAdSetMutation,
    createAdMutation,
    setOptimisticMetaAdAccounts,
    getCurrentAdAccounts,
    showSuccessMessage,
    showErrorMessage,
    logger: loggerInstance,
  } = deps;

  // Create the optimistic state service first
  const optimisticStateService = createOptimisticStateService({
    setOptimisticMetaAdAccounts,
    getCurrentAdAccounts,
    logger: loggerInstance,
  });

  // Create the boost post service with optimistic state integration
  const boostPostService = createBoostPostService({
    createCampaignMutation,
    createAdSetMutation,
    createAdMutation,
    updateOptimisticState: optimisticStateService.updateAdAccounts,
    showSuccessMessage,
    showErrorMessage,
    logger: loggerInstance,
  });

  return {
    boostPostService,
    optimisticStateService,
  };
};
